import styled from 'styled-components';

export const _Title = styled.h1`
  font-size: ${(props) => props.theme.fontsizeH1Mobile};
  font-weight: ${(props) => props.theme.fontWeightBold}
  margin-top: 20px;
  margin-bottom: 15px;
  font-family: ${(props) => props.theme.fontFamilySecondary};
  font-weight:  ${(props) => props.theme.fontWeightBold};
  color:  ${(props) => props.theme.fontColorPrimary};
  text-align: left;
  text-transform: ${(props) => props.theme.headingTransform};

  @media (min-width: 768px) {
    margin-top: revert;
    font-size: ${(props) => props.theme.fontsizeH1Desktop};
  }
`;

export const _PageTitle = styled(_Title)`
  display: flex;
  flex: 1;
  padding-bottom: 15px;
  border-bottom: 1px solid #1b5f4b;
`;
